import type { HTTPClientV3 } from "../HTTPClientV3";

export interface ManagerJwtResponse {
  jwt?: string;
}

export interface ManagerCodeResponse {
  data?: {
    id?: string;
    type?: string;
    attributes?: {
      code?: string;
    };
  };
  code?: string; // fallback for direct code response
}

const base = `/managers`;
const buyerToManagerCodeUrl = `/authentication_codes/buyer_to_manager`;
const becomeSellerUrl = `/authentication_codes/become_seller`;

export async function acceptInvitation(APIV3: HTTPClientV3) {
  const response = await APIV3.put<ManagerJwtResponse>(`${base}/invitations`);
  return response.json();
}

export async function getBuyerToManagerCode(APIV3: HTTPClientV3) {
  const response = await APIV3.post<ManagerCodeResponse>(
    `${buyerToManagerCodeUrl}`,
  );
  return response.json();
}

export async function getManagerCodeAndBecomeSeller(APIV3: HTTPClientV3) {
  const response = await APIV3.post<ManagerCodeResponse>(`${becomeSellerUrl}`);
  return response.json();
}
